"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React from "react"
import Snackbar from "@mui/material/Snackbar"
import MuiAlert from "@mui/material/Alert"
import updateSuccessMessage from "../../../graphql/mutations/snackbarMessage/updateSuccessMessage"
import updateErrorMessage from "../../../graphql/mutations/snackbarMessage/updateErrorMessage"
import updateWarningMessage from "../../../graphql/mutations/snackbarMessage/updateWarningMessage"
import { useReactiveVar } from "@apollo/client/react"
import {
  successMessageVar,
  warningMessageVar,
  errorMessageVar,
  SnackbarMessageState,
} from "../../../graphql/reactiveVars"

const Alert = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof MuiAlert>
>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

function SnackbarMessage() {
  const warningMessage = useReactiveVar(warningMessageVar)
  const errorMessage = useReactiveVar(errorMessageVar)
  const successMessage = useReactiveVar(successMessageVar)

  const handleClose =
    (updateFunction: (message: SnackbarMessageState | null) => void) =>
    (_event?: React.SyntheticEvent | Event, reason?: string) => {
      if (reason === "clickaway") return
      updateFunction(null)
    }

  const renderMessage = (
    messageData: SnackbarMessageState | null,
    type: "error" | "success" | "warning",
    updateFunction: (message: SnackbarMessageState | null) => void,
  ) => {
    if (!messageData) return null
    const { message, duration } = messageData

    return (
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={Boolean(message)}
        autoHideDuration={duration}
        onClose={handleClose(updateFunction)}
        key={`${type}-message-snackbar`}
      >
        <Alert onClose={handleClose(updateFunction)} severity={type}>
          {message}
        </Alert>
      </Snackbar>
    )
  }

  return (
    <>
      {renderMessage(errorMessage, "error", updateErrorMessage)}
      {renderMessage(successMessage, "success", updateSuccessMessage)}
      {renderMessage(warningMessage, "warning", updateWarningMessage)}
    </>
  )
}

export default SnackbarMessage
